import Swiper from "swiper";
import { Pagination } from "swiper/modules";
Swiper.use([Pagination]);

(function () {
  const tileSlider = document.querySelectorAll(".tile-slider");
  let tileSwiper = [];

  for (let i = 0; i < tileSlider.length; i++) {
    tileSwiper[i] = new Swiper(tileSlider[i], {
      loop: false,
      slidesPerView: 1,
      spaceBetween: 15,
      pagination: {
        el: ".tile-swiper-pagination",
        clickable: true,
      },
    });
  }
})();
